import './fundraiser-banner.css';

const FundraiserBanner = () => {
    const fundraiserLink = 'https://www.zeffy.com/en-US/ticketing/crystal-beach-7-night-getaway';

    return (
        <div className="fundraiser-banner">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-7 col-12">
                        <div className="fundraiser-content">
                            <span className="fundraiser-memorial">7 Night Crystal Beach Getaway + $500 Southwest Giftcard</span>
                            <span className="fundraiser-text">Enter for a chance to win this amazing getaway! Only 100 tickets being sold!</span>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5 col-12 text-end">
                        <a
                            href={fundraiserLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="donate-button"
                        >
                            Buy Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FundraiserBanner;
